// Components/CaseNavigator/CaseNavigatorModalContext.js

import { createContext } from "react";

export const CaseNavigatorModalContext = createContext();
